export enum ResidentState {
  ENABLED = 'Enabled',
  IN_HOSPITAL = 'In Hospital',
  OUT_OF_CARE = 'Out Of Care',
  DISABLED = 'Disabled',
  ARCHIVED = 'Archived',
  HIDDEN = 'hidden',
}
